import PropTypes from 'prop-types'

const organization = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
})

const user = PropTypes.shape({
  id: PropTypes.number,
  email: PropTypes.string,
})

const site = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
})

const prescriber = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
  npi: PropTypes.string,
})

const client = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  current_version: PropTypes.string,
})

const device = PropTypes.shape({
  device_string: PropTypes.string
})

const pharmacy = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  fax_number: PropTypes.string,
  emails: PropTypes.arrayOf(PropTypes.string)
})

const patient = PropTypes.shape({
  first_name: PropTypes.string,
  last_name: PropTypes.string
})

const interfaceVersion = PropTypes.shape({
  id: PropTypes.number,
  version: PropTypes.string,
  details: PropTypes.string,
  user_id: PropTypes.string,
})

const updatedInterfaceVersion = PropTypes.shape({
  client: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  version: PropTypes.shape({
    details: PropTypes.string,
    id: PropTypes.number,
    user_id: PropTypes.number,
    version: PropTypes.string,
  })
})

const PROPTYPES = {
  organization,
  organizations: PropTypes.arrayOf(organization),
  patient,
  patients: PropTypes.arrayOf(patient),
  user,
  users: PropTypes.arrayOf(user),
  site,
  sites: PropTypes.arrayOf(site),
  prescriber,
  prescribers: PropTypes.arrayOf(pharmacy),
  device,
  devices: PropTypes.arrayOf(device),
  pharmacy,
  pharmacies: PropTypes.arrayOf(pharmacy),
  clients: PropTypes.arrayOf(client),
  interfaceVersion,
  updatedInterfaceVersion,
}

export default PROPTYPES



// WEBPACK FOOTER //
// ./src/lib/propTypes.js